import { useNavigate, useParams } from "react-router-dom";
import { Subtree } from "subtree.js/react";
import { pick } from "trunk.js";
import type { AppDeps } from "../../app-deps";
import { LiveBreakController } from "./live-break-controller";
import { LiveBreakPage } from "./live-break-page";

export function LiveBreakRoute({ deps }: { deps: AppDeps }) {
  const { breakId = "" } = useParams();
  const navigate = useNavigate();
  return (
    <Subtree
      key="live-break"
      deps={[breakId]}
      controller={() =>
        new LiveBreakController(
          pick(deps, "client", "authHandler", "shareLinks"),
          { toQueue: () => navigate("/live") },
          breakId,
        )
      }
    >
      <LiveBreakPage />
    </Subtree>
  );
}
